/** RMS API client for admin merchant SBR margin groups (load/save, shipment options). */
import {injectable} from "inversify";
import {TYPE, rootContainer} from '../container/root';
import {IApiResponse, IHttpService} from "../http-service";
import {ISbrMarginGroup} from "../../pages/admins/sbr-margin-groups/types";
import {IShipmentOptionsForSelectionResponseDto} from "../../pages/return-methods/return-method-types";

export interface IMerchantSbrMarginGroupsResponse {
    sbr_margin_groups: ISbrMarginGroup[];
}

@injectable()
class AdminManageMerchantsSbrMarginsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchMerchantSbrMarginGroups(merchant_id: number): Promise<IMerchantSbrMarginGroupsResponse> {
        const res = await this.httpService.get<IApiResponse<IMerchantSbrMarginGroupsResponse>>(
            `/rms-api/admin-merchants-sbr-margins-editor/${merchant_id}`
        );
        return res.payload;
    }

    async fetchSbrShipmentOptions(): Promise<IShipmentOptionsForSelectionResponseDto> {
        const res = await this.httpService.get<IApiResponse<IShipmentOptionsForSelectionResponseDto>>(
            '/rms-api/admin-merchants-sbr-margins-editor/sbr-shipment-options'
        );
        return res.payload;
    }

    async updateMerchantSbrMarginGroups(
        merchant_id: number,
        sbr_margin_groups: ISbrMarginGroup[]
    ): Promise<IMerchantSbrMarginGroupsResponse> {
        const res = await this.httpService.post<IApiResponse<IMerchantSbrMarginGroupsResponse>>(
            `/rms-api/admin-merchants-sbr-margins-editor/${merchant_id}`,
            {sbr_margin_groups}
        );
        return res.payload;
    }
}

export default AdminManageMerchantsSbrMarginsService;
